<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="8">
                        <span class="title">姓名:</span>
                        <!-- 搜索姓名 -->
                        <el-input
                            v-model="search_data.name"
                            placeholder="请输入姓名"
                            class="handle-input mr10"
                            @keyup.enter.native="searchserviceFeeLogDriverLists"
                        ></el-input>
                    </el-col>
                    <el-col :span="8">
                        <span class="title">司机手机号:</span>
                        <!-- 搜索商家手机号 -->
                        <el-input
                            v-model="search_data.phone"
                            placeholder="请输入司机手机号"
                            class="handle-input mr10"
                            @keyup.enter.native="searchserviceFeeLogDriverLists"
                        ></el-input>
                    </el-col>
                </el-row>
                <el-row class="head-search">
                    <el-col :span="24" style="margin-top: 10px">
                        <span class="title">起止时间:</span>

                        <el-date-picker
                            v-model="search_time"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="timeChange"
                            style="width: 300px"
                        >
                        </el-date-picker>
                    </el-col>
                </el-row>
            </div>

            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button type="primary" icon="el-icon-search" @click="searchserviceFeeLogDriverLists">搜索</el-button>
            <el-button :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'" @click="toExport" :disabled="progress_show">{{
                progress_show ? '导出中...' : '导出'
            }}</el-button>
            <!-- 导出进度条 -->
            <div style="width: 500px; margin: 10px auto" v-if="progress_show">
                <el-progress :percentage="progress_data"></el-progress>
                <i class="el-icon-loading"></i>
                正在导出...
            </div>
        </div>

        <!-- 表格 -->
        <el-table
            :data="tableData"
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handleSelectionChange"
        >
            <!-- <el-table-column type="selection" width="55">
            </el-table-column> -->
            <el-table-column prop="city.name" label="城市名称"> </el-table-column>
            <el-table-column prop="driver.name" label="姓名"> </el-table-column>
            <el-table-column prop="driver.phone" label="电话"> </el-table-column>

            <el-table-column prop="amount" label="服务费金额"> </el-table-column>

            <el-table-column prop="money_flow" label="资金流向"> </el-table-column>

            <el-table-column prop="time.YmdHis" label="创建时间"> </el-table-column>
            <el-table-column prop="mode.alias" label="模式"> </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
    </div>
</template>

  <script>
var _this;

export default {
    components: {},
    data() {
        return {
            excelData: [],

            excelHead: [],

            progress_show: false,
            progress_data: 0,

            search_time: '',
            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                driver_fixed_array: '',
                name: '',
                phone: ''
            },

            result_data: [],

            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.searchserviceFeeLogDriverLists();
    },

    methods: {
        // 全选或多选
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection);

            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].fee_count_log_code);
            }
            _this.search_data.fee_count_log_code_array = datalist;
            // console.log(_this.search_data.fee_count_log_code_array);
            // console.log(datalist);
        },

        timeChange(val) {
            console.log(val);

            if (val != null) {
                _this.search_data.driver_fixed_array = JSON.stringify(['between', ..._this.search_time]);
            } else {
                _this.search_data.driver_fixed_array = '';
            }
        },
        searchserviceFeeLogDriverLists() {
            _this.search_data.page = 1;

            _this.serviceFeeLogDriverLists();
        },

        //搜索公司列表
        serviceFeeLogDriverLists() {
            console.log(_this.search_data);
            _this
                .$post('/service_fee/serviceFeeLogDriverLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.result_data = res.data;
                    _this.tableData = res.data.result;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.serviceFeeLogDriverLists();
        },
        // 刷新按钮
        refresh() {
            this.$router.go(0);
        },
        toExport() {
            _this.search_data.page = 1;
            _this.getExcelData();
        },

        getExcelData() {
            _this
                .$post('/service_fee/serviceFeeLogDriverLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    _this.progress_show = true;

                    // console.log(_this.progress_show);

                    if (this.$route.path == '/serviceFeeLogDriverLists') {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.result.length; i++) {
                            _this.excelData.push({
                                city: res.data.result[i].city.name,
                                driver: res.data.result[i].driver.name,
                                phone: res.data.result[i].driver.phone,
                                amount: res.data.result[i].amount,
                                money_flow: res.data.result[i].money_flow,
                                time: res.data.result[i].time.YmdHis,
                                mode: res.data.result[i].mode.alias
                            });
                        }

                        if (res.data.page * res.data.limit < res.data.count) {
                            _this.search_data.page = res.data.page + 1;

                            _this.progress_data = Math.floor(((res.data.page * res.data.limit) / res.data.count) * 100);

                            _this.getExcelData();
                        } else {
                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;
                        }
                    } else {
                        _this.progress_show = false;
                        _this.progress_data = 0;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['城市名称', '姓名', '电话', '服务费金额', '资金流向', '创建时间', '模式'];
            const filterVal = ['city', 'driver', 'phone', 'amount', 'money_flow', 'time', 'mode'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '司机服务费流水');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}

</style>
